import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import "../../../Cyclone/DisturbanceTrack/DisturbanceTrack.css";
import FeltReport from "../FeltReport/FeltReport";
import Addlightningdeathrecord from "../DeathData/Addlightningdeathrecord";

const TABS = [
  { id: "feltreport", label: "Felt Report" },
];

const Forms = () => {
  const [searchParams] = useSearchParams();
  const initialTab = TABS.some((tab) => tab.id === searchParams.get("tab"))
    ? searchParams.get("tab")
    : "feltreport";
  const [activeSection, setActiveSection] = useState(initialTab);

  return (
    <div style={{ marginBottom: "1rem" }}>
      <div className="section-buttons-container" style={{ border: "0px" }}>
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`section-button ${activeSection === tab.id ? "active" : ""}`}
            onClick={() => setActiveSection(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="section-content-container">
        <div className={`section-container ${activeSection === "feltreport" ? "active-section" : "hidden-section"}`}>
          <FeltReport />
        </div>
        <div className={`section-container ${activeSection === "deathdata" ? "active-section" : "hidden-section"}`}>
          <Addlightningdeathrecord />
        </div>
      </div>
    </div>
  );
};

export default Forms;
